<template>
  <div class="bubble-wrapper">
    <!-- <vue-headful
    title="Dachaudenktweiter"
    />-->
    <!-- <div class="left-bubble"> -->
    <!-- <img src="../assets/grafiken/startseite/sprechblase_intro.png"> -->
    <!-- <LogoCountdown :daysLeft="daysLeft" /> -->
    <!-- </div> -->
    <div class="right-bubble">
      <transition-group name="fade" mode="out-in">
        <img
          v-for="(slide, i) in slides"
          :key="i"
          v-if="count-1 === i"
          :src="slide.src"
          :class="{cursor : slide.link}"
          @click="onSlideClick(slide.link)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import LogoCountdown from "@/components/LogoCountdown";
export default {
  metaInfo: {
    title: "DachauDenktWeiter",
    titleTemplate: null
  },
  components: {
    LogoCountdown
  },
  data() {
    return {
      slides: [
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img1.png"),
          link: null
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img2.png"),
          link: "/aktuelles"
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img3.png"),
          link: "/aktuelles"
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img4.png"),
          link: "/aktuelles"
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img5.png"),
          link: "/aktuelles"
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img6.png"),
          link: "/aktuelles"
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img7.png"),
          link: "/aktuelles"
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img8.png"),
          link: "/bericht"
        },
        {
          src: require("../assets/grafiken/startseite/sprechblasen/img9.png"),
          link: "/umfrage"
        }
      ],
      button: {
        route: "",
        text: ""
      },
      count: 0,
      show: true,
      buttonShow: "/machmit"
    };
  },
  computed: {
    daysLeft() {
      let x = new Date();
      let y = new Date("July 27, 2019 00:00:00");
      let z = y - x;
      let result = Math.ceil(z / 1000 / 60 / 60 / 24);
      return result;
    }
  },
  methods: {
    counter() {
      this.count++;
      setInterval(() => {
        if (this.count >= this.slides.length) {
          this.count = 0;
        }
        this.count++;
      }, 5000);
    },
    onSlideClick(link) {
      if (link) this.$router.push(link);
    }
  },
  created() {
    this.counter();
  }
};
</script>
<style scoped lang="scss">
.bubble-wrapper {
  // background-image: url(../assets/grafiken/wolken.png);
  // background-repeat: repeat;
  // background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 120px;
  width: 100%;
  .left-bubble {
  }
  .right-bubble {
    position: relative;
    img {
      position: absolute;
    }
  }
  & > div {
    height: 500px;
    width: 100%;
    padding: 5px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

@media (min-width: 768px) {
  .bubble-wrapper {
    background-size: contain;
    height: calc(100% - 400px);
    flex-direction: row;
    align-items: center;
    margin-top: 210px;
    & > div {
      height: 100%;
      width: 100%;
    }
    & > div img {
      // padding: 20px;
    }
  }
  .left-bubble {
    flex: 2;
  }
  .right-bubble {
    flex: 5;
  }
}

//Transition fade
.fade-enter-active {
  animation: fade 2s;
}
.fade-leave-active {
  animation: fade 2s reverse;
}
@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.cursor {
  cursor: pointer;
}
</style>
